import { render, staticRenderFns } from "./ProjectIntstuctions.vue?vue&type=template&id=44ebedf5&scoped=true&"
import script from "./ProjectIntstuctions.vue?vue&type=script&lang=js&"
export * from "./ProjectIntstuctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ebedf5",
  null
  
)

export default component.exports